module.exports = __webpack_public_path__ + "static/media/3.09965ad1.jpg";